import React from 'react';
import './TableSkeleton.css';

interface SkelColumn {
  header?: React.ReactNode;
  width?: string | number;
}

interface TableSkeletonProps {
  /** Memes colonnes que TableauDeBord : on en reprend les en-tetes et largeurs. */
  columns: SkelColumn[];
  /** Nombre de lignes factices. */
  rows?: number;
}

/**
 * Skeleton fidele du TableauDeBord : meme structure/classes (.tableau-container,
 * .tableau, .sortable-header) -> herite du style exact de la table. En-tetes reels,
 * lignes en placeholder shimmer. Remplace le spinner pendant le chargement.
 */
const TableSkeleton: React.FC<TableSkeletonProps> = ({ columns, rows = 8 }) => (
  <div className="tableau-container table-skeleton" aria-hidden="true" aria-busy="true">
    <table className="tableau">
      <thead>
        <tr>
          {columns.map((col, i) => (
            <th
              key={i}
              className="sortable-header"
              style={col.width ? { width: col.width, minWidth: col.width } : undefined}
            >
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, r) => (
          <tr key={r} className="table-skel-row">
            {columns.map((_, c) => (
              <td key={c}>
                <span className="tskel" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default TableSkeleton;
